import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { isOrdersBasketColumnVisible } from 'state/orders-basket/selectors';
import type { AppState } from 'state/state.model';

import type { OrdersBasketHeaderCellOwnProps, OrdersBasketHeaderCellStateProps } from './OrdersBasketHeaderCell.model';

const mapStateToProps: MapStateToProps<OrdersBasketHeaderCellStateProps, OrdersBasketHeaderCellOwnProps, AppState> = (
  state: AppState,
  ownProps: OrdersBasketHeaderCellOwnProps,
) => ({
  isVisible: isOrdersBasketColumnVisible(
    state,
    { productSubType: ownProps.productSubType, productType: ownProps.productType },
    ownProps.fieldId,
  ),
});

export const connectOrdersBasketHeaderCellComponent = connect(mapStateToProps);
